module.exports = "/_next/static/images/slide-1-c516b8322f598982358e0ad3e2f36045.png";